module.exports = {
	"data": {
		"allFile": {
			"edges": [
				{
					"node": {
						"relativePath": "community/articles-and-videos.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Articles & Videos",
								"order": 10
							}
						}
					}
				},
				{
					"node": {
						"relativePath": "community/blog.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Blog",
								"order": 0
							}
						}
					}
				},
				{
					"node": {
						"relativePath": "community/companies.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Companies",
								"order": 60
							}
						}
					}
				},
				{
					"node": {
						"relativePath": "community/events.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Events",
								"order": 30
							}
						}
					}
				},
				{
					"node": {
						"relativePath": "community/examples.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Examples",
								"order": 20
							}
						}
					}
				},
				{
					"node": {
						"relativePath": "community/faq.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Frequently Asked Questions",
								"order": 40
							}
						}
					}
				},
				{
					"node": {
						"relativePath": "community/index.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Community",
								"order": 0
							}
						}
					}
				},
				{
					"node": {
						"relativePath": "community/roadmap.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Roadmap & Contribution",
								"order": 50
							}
						}
					}
				}
			]
		},
		"file": {
			"relativePath": "community/index.md",
			"childMarkdownRemark": {
				"html": "<p>This is where we keep track of all the awesome things happening in the community.</p>\n<p>Come say hi!</p>\n<ul>\n<li><a href=\"https://discord.gg/reasonml\">Discord</a></li>\n<li><a href=\"https://twitter.com/reasonml\">Twitter</a></li>\n<li><a href=\"https://www.reddit.com/r/reasonml/\">Reddit</a></li>\n<li><a href=\"http://stackoverflow.com/questions/tagged/reason\">Stack Overflow</a></li>\n<li>IRC (freenode #reasonml)</li>\n</ul>\n<h3 id=\"github\"><a href=\"#github\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Github</h3>\n<ul>\n<li><a href=\"https://github.com/reasonml\">Reason Org</a></li>\n<li><a href=\"https://github.com/reasonml-community\">Reason Community Org</a></li>\n<li><a href=\"https://github.com/reasonml-editor\">Reason Editor Plugins</a></li>\n</ul>",
				"frontmatter": {
					"title": "Community"
				}
			}
		}
	},
	"pathContext": {
		"section": "community",
		"sectionTitle": "Community",
		"relativePath": "community/index.md",
		"relatedFiles": "/^community\\/.*\\.md$/"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/community.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/community.json
// module chunks = 54